<template>
  <div class="container">
    <div class="top">
      <table></table>
      <p style="margin-left: 25px; margin-top: 15px">{{ obj.state }}</p>
    </div>
    <div class="flex01">
      <img :src="obj.cover" alt="" />
      <div>
        <p style="word-break: break-all">{{ obj.title }}</p>
        <p style="color: #999999" v-if="obj.type_front == 1">实物</p>
        <p style="color: #999999" v-else-if="obj.type_front == 2">虚拟</p>
        <p style="color: #999999" v-else-if="obj.type_front == 3">积分</p>
        <p style="color: #dfbd91; margin-top: 10px">{{ obj.score }}积分</p>
      </div>
    </div>
    <div class="main">
      <div class="flex02">
        <p class="title">兑换时间:</p>
        <p class="detail">{{ obj.createtime_str }}</p>
      </div>
      <div class="flex02">
        <p class="title">兑换积分:</p>
        <p class="detail">{{ obj.score }}积分</p>
      </div>
    </div>
    <div class="bottom">
      <div class="flex03">
        <p class="grey" v-if="obj.star == 0">订单已完成请评价</p>
        <p class="grey" v-else>订单已完成</p>
        <p class="grey">
          好评度
          <span class="black" style="font-weight: bold"
            >{{ obj.nice_per }}%</span
          >
        </p>
      </div>
      <div class="flex03" style="margin-top: 10px">
        <p class="grey">服务评价:</p>
        <van-rate
          v-model="star"
          :size="25"
          color="#ffd21e"
          void-icon="star"
          void-color="#eee"
          :readonly="readonly"
        />
      </div>
      <p v-if="obj.star != 0 && obj.content == ''">并未留下留言</p>
      <van-field
        v-model="message"
        rows="4"
        autosize
        type="textarea"
        placeholder="请输入留言"
        :readonly="readonly"
      />
      <div class="bt" v-if="obj.star == 0" @click="submit">提交</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "jfrecorddetail",
  data() {
    return {
      star: 5,
      message: "",
      obj: {},
      readonly: false,
    };
  },
  created() {
    if (!this.$route.query.id) {
      this.$router.push("/jfrecord");
    }
  },
  mounted() {
    this.$toast.loading({
      duration: 0,
      forbidClick: true,
    });
    this.$axios({
      method: "post",
      url: "/api/score/orderinfo",
      data: this.qs.stringify({
        order_id: this.$route.query.id,
      }),
    }).then((res) => {
      this.$toast.clear();
      if (res.data.code != 0) {
        this.$toast(res.data.msg);
      } else {
        this.obj = res.data.data;
        this.message = this.obj.comment;
        if (this.obj.star == 0) {
          this.readonly = false;
        } else {
          this.star = this.obj.star;
          this.readonly = true;
        }
      }
    });
  },
  methods: {
    init() {
      this.$axios({
        method: "post",
        url: "/api/score/orderinfo",
        data: this.qs.stringify({
          order_id: this.$route.query.id,
        }),
      }).then((res) => {
        if (res.data.code != 0) {
          this.$toast(res.data.msg);
        } else {
          this.obj = res.data.data;
          this.message = this.obj.comment;
          if (this.obj.star == 0) {
            this.readonly = false;
          } else {
            this.star = this.obj.star;
            this.readonly = true;
          }
        }
      });
    },
    submit() {
      if (this.star == 0) {
        this.$toast("请选择星级");
        return;
      }
      this.$toast.loading({
        duration: 0,
        forbidClick: true,
      });
      this.$axios({
        method: "post",
        url: "/api/score/comment",
        data: this.qs.stringify({
          order_id: this.$route.query.id,
          star: this.star,
          comment: this.message,
        }),
      }).then((res) => {
        this.$toast.clear();
        if (res.data.code == 0) {
          this.init();
          this.$forceUpdate();
        } else {
          this.$toast(res.data.msg);
        }
      });
    },
  },
};
</script>
<style scoped>
.container {
  min-height: 100vh;
  background: #f5f5f5;
}
.top {
  background: #cab586;
  color: white;
  font-size: 24px;
  font-weight: bold;
  height: 120px;
}
.flex01 {
  display: flex;
  margin: 10px;
  background: white;
  border-radius: 10px;
  padding: 15px;
  margin-top: -54px;
}
.flex01 img {
  width: 73px;
  height: 73px;
  object-fit: cover;
  border-radius: 15px;
  flex-shrink: 0;
  margin-right: 10px;
}
.flex01 div {
  width: 100%;
}
.main {
  margin: 10px;
  border-radius: 10px;
  background: white;
  padding: 0 15px;
  font-size: 14px;
}
.flex02 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  border-bottom: 1px solid #bbbbbb;
}
.title {
  font-weight: bold;
}
.detail {
  color: #999999;
}
.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px;
  background: white;
}
.flex03 {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.black {
  color: rgba(16, 16, 16, 100);
}
.grey {
  color: #999999;
}
.van-cell {
  padding: 10px;
  margin: 10px 0;
  border: 1px solid #3894ff;
  border-radius: 10px;
}
.bt {
  color: white;
  background: #cab586;
  height: 34px;
  width: 189px;
  margin: 15px auto;
  text-align: center;
  line-height: 34px;
  font-size: 18px;
  border-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/jfrecorddetail.vue